import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-opacity": ".9",
  "stroke-width": "2",
  d: "M15.5 4h3.682a3 3 0 0 1 2.994 2.813l.625 10A3 3 0 0 1 19.807 20h-1.979a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 14.172 18H9.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 6.172 20H4.193A3 3 0 0 1 1.2 16.813l.625-10A3 3 0 0 1 4.82 4h5.563a1 1 0 0 0 .895-.553L12 2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "11",
  r: "3",
  stroke: "#CF0",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CF0",
  "stroke-linecap": "round",
  "stroke-width": "2",
  d: "m15.5 14.5-1-1"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }